import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Button
} from 'reactstrap';
import classNames from 'classnames';

import { getAdditionalPage } from '../../actions/productAction';
import { Banner, Content } from '../Assets';
import FilterAndSort from '../../components/PageSearchDetails/FilterAndSort';
import { isFromAppBrowser } from '../../utils/Helpers';
import SneakerLoadingSpinner from '../../components/Sneakers/SneakerLoadingSpinner';
import { ASSET_IMAGE, RESOURCE_URL } from '../../config'

class Upcoming extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true
    }
  }

  componentDidMount() {
    let options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.7
    };
    const isInfiniteScrolL = !isFromAppBrowser();
    this.setState({ isInfiniteScrolL })
    this.getProductList();
    if(isInfiniteScrolL){
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this), // pass the callback
        options
      );
      this.observer.observe(this.loadingRef);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if(prevProps.dataProduct.stillPending && !this.props.dataProduct.stillPending){
      const { pagination } = this.props.dataProduct;
    
      this.setState({
        hasMore: pagination !== null,
        loading: false
      })
    }
    if(prevProps.dataCategory !== this.props.dataCategory){
      const { dataCategory } = this.props;
      await this.setState({ page: 1, loading: true, hasMore: true, prevY: 0 });
      this.getProductList();
    }
  }

  getProductList = () => {
    const { dataCategory } = this.props;
    const { page } = this.state;

    this.setState({ loading: true });

    this.props.getAdditionalPage('unreleased', { params: { page, category: dataCategory }})
    .then(() => {
      this.setState({ loading: false, page: page + 1 })
    })
    .catch(() => {
      this.setState({ loading: false })
    })
  }
  

  _handleNextPageClick = async () => {
    if(!this.state.loading && this.state.hasMore){
      const { dataCategory } = this.props;
      this.getProductList();
    }
  }

  async handleObserver(entities, observer) {
    const { dataProduct: { pagination, stillPending }, dataCategory } = this.props;
    
    const y = entities[0].boundingClientRect.y;
    if (pagination !== null && !this.state.loading) {
      if (this.state.prevY > y) {
        this.getProductList();
      }
      this.setState({ prevY: y });
    } else if (pagination === null && this.state.hasMore) {
      if (this.state.page === 1) {
        if (this.state.prevY > y) {
          const curPage = this.state.page + 1;
          this.getProductList();
        }
        this.setState({ prevY: y });
      } else {
        this.setState({
          loading: false
        })
      }
    } 
  }

  render() {
    // const loadingTextCSS = { 
    //   display: this.state.loading ? 'block' : 'none',
    //   width: '170px',
    //   height: '170px',
    //   textAlign: 'center',
    // };
    // const loadingCSS = {
    //   textAlign: 'center',
    //   height: '100px',
    //   margin: '30px',
    //   display: 'flex',
    //   justifyContent: 'center'
    // };

    return (
      <Container fluid className="main-container" id="home-container">
        <Banner 
          src={`${ASSET_IMAGE}/assets-image/upcoming-details.jpg`}
          alt={`${RESOURCE_URL}/assets-image/upcoming-details.jpg`}
        />
        <div className="product-list">
          <Content statusPage="unreleased" />
          {
            !this.state.isInfiniteScrolL?
              <div className="d-flex justify-content-center">
                <Button
                  block
                  size={"lg"}
                  type="button"
                  onClick={this._handleNextPageClick}
                  className={classNames('button-load-more browse__all',{'d-none': this.state.loading || !this.state.hasMore})}
                >
                  Load More
                </Button>
              </div>
            :null
          }
          <SneakerLoadingSpinner
            isLoading={this.state.loading && this.state.page > 1}
            isHide={!this.state.hasMore}
            wrapperRef={loadingRef => this.loadingRef = loadingRef}
          />
        </div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  dataProduct:state.dataProduct,
  dataCategory: state.dataCategory.selected
})

const mapDispatchToProps = dispatch => ({
  getAdditionalPage: (type, params) => dispatch(getAdditionalPage(type, params))
})

export default connect(mapStateToProps, mapDispatchToProps)(Upcoming);
